import { Fragment } from "react";

import { dehydrate, QueryClient, useQuery } from '@tanstack/react-query';
import { getQueryFn, queryKeyManager } from "../../utils/api/queryFunction";
import queryConfig from "../../utils/api/queryConfig";

import { GetServerSideProps, InferGetServerSidePropsType } from "next";
import { isArray } from "remeda";

import OurStoryBuilder from '../../components/Shared/Builders/OurStoryBuilder'

import ProductLayout from "../../components/Layout/ProductLayout";

import Seo from "../../components/Shared/SEO";

import SmallBanner from "../../components/Shared/Banners/SmallBanner";

type PageProps = InferGetServerSidePropsType<typeof getServerSideProps>;

const Page = (props: PageProps) => {
	const { token } = props;

	const { isLoading, data } = useQuery({
		queryKey: queryKeyManager(["our-story"], [token]),
		queryFn: () => getQueryFn('our-story', token),
		...queryConfig
	});

	if (isLoading) {
		return <span />;
	}

	return (
		<Fragment>
			<Seo seo={data.seo} />
			<ProductLayout nav={data.nav.header.links} logo={data.nav.header.logos.general} footer={data.nav.footer}>
				<SmallBanner banner={data.banner} />
				{/* Load builder */}
				<OurStoryBuilder builder={data.builder} />
			</ProductLayout>
		</Fragment>
	);
};

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
	const queryClient = new QueryClient();

	const { token = null } = query;

	await queryClient.prefetchQuery({
		queryKey: queryKeyManager(["our-story"], [token]),
		queryFn: () => getQueryFn('our-story', isArray(token) ? token[0] : token),
		...queryConfig
	});

	return {
		props: {
			token: token,
			dehydratedState: dehydrate(queryClient)
		}
	};
}

export default Page;